import { render, staticRenderFns } from "./InvoicesTableTotal.vue?vue&type=template&id=642a5c8a&"
import script from "./InvoicesTableTotal.vue?vue&type=script&lang=js&"
export * from "./InvoicesTableTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports